export enum GjsActionTypes {
	None = "",
	MoveToStep = "goto_step",
	NextStep = "next_step",
	PreviousStep = "previous_step",
	OpenURL = "open_url",
	OpenAttachment = "open_attachment",
	ScenarioLink = "project_link",
	FinishProcedure = "finish_procedure",
	RetryQuiz = "retry_quiz",
	CompleteQuiz = "complete_quiz",
	PlayVideo = "video_inset_clicked",
	PlayAudio = "audio_inset_clicked",
	EnlargeCamera = "enlarge_camera",
	FullScreen = "fullscreen",
}

export enum GjsAttributeNames {
	ID = "id",
	Action = "data-action",
	ParamStepID = "param-step-id",
	AssetID = "asset-id",
	ParamURL = "param-url",
	ParamScenario = "param-scenario",
	ParamScenarioMode = "param-scenario-mode",
	CoverAssetID = "cover-asset-id",
	MetaType = "data-meta-type",
	ParamCameraID = "param-camera-id",
	AssetPath = "data-asset-path",
	OnClick = "onclick",
	ImageSource = "src",
	SmartIdentifier = "data-smart-identifier",
	ActivationText = "data-activation-text",
	VoiceOver = "data-voice-over",
	NoActions = "data-no-actions",
	NotDeletable = "data-not-deletable",
	NotResizable = "data-not-resizable",
	NotCopiable = "data-not-copiable",
}

export enum GjsComponentDataFields {
	PrevDisplay = "__prev-display",
	CustomName = "custom-name",
	Content = "content",
}

export enum GjsEditorCommands {
	OpenAssets = "open-assets",
	OpenStepPicker = "open-step-picker",
	OpenScenarioPicker = "open-scenario-picker",
	OpenCameraPicker = "open-camera-picker",
}

export enum GjsTraitTypes {
	Content = "content",
	ActionSelect = "action_select",
	StepPicker = "step_picker",
	ImagePicker = "image_picker",
	VideoPicker = "video_picker",
	AudioPicker = "audio_picker",
	AttachmentPicker = "attachment_picker",
	UrlInput = "url_input",
	ScenarioPicker = "scenario_picker",
	ScenarioMode = "scenario_mode",
	ScenarioNameInput = "scenario_name_input",
	CoverImagePicker = "cover_image_picker",
	CameraPicker = "camera_picker",
}

export enum GjsMetaTypes {
	Camera = "camera",
	Video = "video",
	Audio = "audio",
}

export enum GjsComponentTypes {
	Video = "inset-video",
	Audio = "inset-audio",
	Camera = "inset-camera",
	Div = "div",
	Text = "e-text",
	Image = "image",
	TextNode = "textnode",
}

export enum GjsCssPropertyNames {
	BackgrounImage = "background-image",
}